import { t } from '@avalara/bat-apps-shared/i18n';
const IossOfferDetails = () => (
  <div className='margin-left-sm margin-top-none pad-top-none'>
    <p className='pad-top-none margin-top-none'>
      {"Our IOSS solution doesn't include tax calculation, so it works best for businesses who sell on marketplaces"}
    </p>
    <p className='pad-top-xs'>{t('client.general.indirect-customs-representation-may-be-required')}</p>
  </div>
);

export default IossOfferDetails;
